import type { ComponentStatus } from '../lib/types';

const STYLE: Record<ComponentStatus, { label: string; dot: string; text: string }> = {
  operational: {
    label: 'Operational',
    dot: 'bg-status-operational',
    text: 'text-status-operational',
  },
  degraded: {
    label: 'Degraded',
    dot: 'bg-status-degraded',
    text: 'text-status-degraded',
  },
  partial_outage: {
    label: 'Partial Outage',
    dot: 'bg-status-partial',
    text: 'text-status-partial',
  },
  major_outage: {
    label: 'Major Outage',
    dot: 'bg-status-major',
    text: 'text-status-major',
  },
  maintenance: {
    label: 'Maintenance',
    dot: 'bg-status-maintenance',
    text: 'text-status-maintenance',
  },
  unknown: {
    label: 'No data',
    dot: 'bg-[var(--color-fg-subtle)]',
    text: 'text-[var(--color-fg-subtle)]',
  },
};

interface Props {
  status: ComponentStatus;
}

export function StatusPill({ status }: Readonly<Props>) {
  const s = STYLE[status];
  return (
    <span className={`inline-flex items-center gap-1.5 font-display text-sm ${s.text}`}>
      <span className={`h-2 w-2 rounded-full ${s.dot}`} aria-hidden />
      {s.label}
    </span>
  );
}
